import React from 'react'
import { useRoute } from '@react-navigation/core'
import { AppRouteProp } from '@src/navigation/types'
import { CompletedComponent } from '@screens/CompletedScreen/CompletedComponent.tsx'

export const CompletedScreen = () => {
  const { params } = useRoute<AppRouteProp<'CompletedScreen'>>()

  const {
    nextScreen,
    nextScreenParams,
    title,
    header,
    introMarkdown,
    icon,
    iconColor,
    showCoachPhoto,
    primaryActionText,
    footnote,
    secondaryActionLink,
    coachPhotoUri,
  } = params

  return (
    <CompletedComponent
      nextScreen={nextScreen}
      nextScreenParams={nextScreenParams}
      onCloseButtonPress={() => {}}
      title={title}
      header={header}
      introMarkdown={introMarkdown}
      icon={icon}
      iconColor={iconColor}
      showCoachPhoto={showCoachPhoto}
      primaryActionText={primaryActionText}
      footnote={footnote}
      secondaryActionLink={secondaryActionLink}
      coachPhotoUri={coachPhotoUri}
    />
  )
}
